<template>
    <div class="BI-content">
        <div class="summary-count">
            <div v-for="(item,index) in columnsArray" :key="index" class="summary-count-item">
              <div class="summary-count-item-lable">
                {{ item.columnName }}
              </div>
              <div  class="summary-count-item-count">
                {{ item.columnCount.toFixed(2) }}
              </div>  
            </div>
        </div>
        <!-- 表单数据 -->
       <div class="form-data-content" v-if="isShowModelFormList==1">
          <DynamicTable
              ref="dynamicTable"
              :showSummary="dataForm.showSummary"
              :tableColumns="tableColumns"
              :subformTableColumns="dataForm.subformTableColumns"
              :tableData="dataForm.pageData"
              :pager="formPage"
              :isLoading="dataForm.tableLoading"
              :isSortable="true"
              :isColumnDrop="true"
              :isShowPageSizes="true"
              :isShowOverflowTooltip="true"
              :tableHeight="dataForm.tableHeight"
              @changePage="queryFormData"
              @changePageSize="queryFormDataByPageSize"
              :key="time"
           />
        </div>
        <!-- BI内容 -->
        <div class="BI-area">
            <!-- 饼状图 -->
            <div class="BI-area-one" v-if="chartType==2">
                <ve-pie :data="chartData" :settings="chartSettings" :height="biHeight" :toolbox="toolbox"></ve-pie>
            </div>
            <!-- 柱状图 -->
            <div class="BI-area-one"  v-if="chartType==1">
                <ve-histogram :data="chartData" :settings="chartSettings" :height="biHeight" :extend="chartExtend" :toolbox="toolbox"></ve-histogram>
            </div>
            <!-- 条形图 -->
            <div class="BI-area-one"  v-if="chartType==3">
                <ve-bar :data="chartData" :settings="chartSettings" :height="biHeight" :extend="chartExtend" :toolbox="toolbox"></ve-bar>
            </div>
            <!-- 折线图 -->
            <div class="BI-area-one"  v-if="chartType==4">
                <ve-line :data="chartData" :settings="chartSettings" :height="biHeight" :extend="chartExtend" :toolbox="toolbox"></ve-line>
            </div>
            <!-- 环形图 -->
            <div class="BI-area-one"  v-if="chartType==5">
                <ve-ring :data="chartData" :settings="chartSettings" :height="biHeight" :toolbox="toolbox"></ve-ring>
            </div>

             <el-row type="flex" justify="end" v-if="showSearch">
                <el-pagination
                    background
                    id="biPager"
                    layout="sizes,total, prev, pager, next"
                    :total="page.totalPageNum"
                    :current-page="page.currentPage"
                    @size-change="handleSizeChange"
                    :page-size="page.pageSize"
                    @current-change="queryTableData"
                    :page-sizes="[20, 30, 50,100]"
                />
            </el-row>
        </div>
        <el-drawer
          :visible.sync="isShowSearchConditon"
          title="搜索"
          :direction="direction"
          size="25vw"
            >
             <div class="search-field" style="height: 100%;">
                 <SearchCondition
                     ref="searchConditon"
                     :key="searchLoadTimer"
                     :isShowLeftModel="false"
                     :conditionFields="conditionFieldsNew"
                     :class="'search-field-box'"
                     :style="'height:82vh;overflow:auto;'"
                     >
                 </SearchCondition>
             </div>
             <div class="opt" style="position: fixed;bottom: 20px;text-align: center;left: 7vw;">
                 <el-button @click="celSetForm">取消</el-button>
                 <el-button type="success" @click="searchForList">确定</el-button>
             </div>
        </el-drawer>
       
        <el-dialog
            append-to-body
            :visible.sync="isShowOrderOptions"
            top="4vh" 
            >
              <div style="margin-bottom:10px;">
                <el-radio-group v-model="sortType">
                <el-radio-button :label="1">指标</el-radio-button>
                <el-radio-button :label="2">纬度</el-radio-button>
                </el-radio-group>
              </div>
              <el-cascader  ref="sortCascader"  :options="orderOptions" clearable v-if="sortType===1"></el-cascader>
              <el-select v-model="sortModel" placeholder="请选择" v-if="sortType===2">
                <el-option :key="1" label="正序" :value="1">正序</el-option>
                <el-option :key="2" label="倒序" :value="2">倒序</el-option>
              </el-select>
              <span slot="footer" class="dialog-footer">
                <el-button @click="isShowOrderOptions = false">取 消</el-button>
                <el-button type="primary" @click="sortSearch">排序查询</el-button>
              </span>
        </el-dialog>
    </div>
</template>

<script>
import { getFormFieldListByIds, getModelFormReportList } from '@/data-model';
import { cloneDeep } from 'lodash';
import DynamicTable from '@/components/DynamicTable/DynamicTable';
export default{
    name: 'BI',
    components: {
        DynamicTable
    },
    props: {
        chartData: {
            type: Object
        },
        chartType: {
            type: Number
        },
        showBiWay: {
            type: Number,
            default: 0
        },
        chartSettings: {
            type: Object
        },
        selectedModel: {
            type: Object
        },
        showSearch: {
            type: Boolean
        },
        showLeftSwitch: {
            type: Boolean,
            default: false
        },
        isShowModelFormList: {
            type: Number,
            default: 0
        },
        isNewPage: {
            type: Boolean,
            default: false
        },
        isCollapseForInit: {
            type: Boolean,
            default: true
        },
        showLeft: {
            type: Boolean,
            default: true
        },
        conditionFields: {
            type: Array
        },
        biConditionFields: {
            type: Array
        },
        isShowBack: {
            type: Boolean,
            default: true
        }
    },
    data () {
        var magicType = [];
        var seriesType = 'bar';
        if (this.chartType === 1 || this.chartType === 3 || this.chartType === 4) {
            magicType = ['line', 'bar'];
            if (this.chartType === 4) {
                seriesType = 'line';
            } else {
                seriesType = 'bar';
            }
        } else if (this.chartType === 2 || this.chartType === 5) {
            magicType = [];
            seriesType = 'pie';
        }
        this.chartExtend = {
            // 柱子宽度
            series: {
                // barWidth: 30
                type: seriesType, // 添加该属性
                label: { show: this.showBiWay === 1, position: 'top' }
            },
            // x轴字体斜显示
            xAxis: {
                axisLabel: {
                    // margin: 15,
                    interval: 0,
                    // rotate: 30,
                    formatter: function (value) {
                        if (value.length > 10) {
                            return value.substring(0, 10).concat('...');
                        } else {
                            return value;
                        }
                    }
                },
                triggerEvent: true
            }
        };
        this.toolbox = {
            // orient: 'horizontal', // 方向
            orient: 'vertical', // 垂直显示
            y: 'center', // 延Y轴居中
            x: 'right', // 居右显示
            feature: {
                myTool1: {
                    show: true,
                    title: '搜索',
                    icon: 'M904.533333 167.822222c-14.222222-31.288889-48.355556-54.044444-85.333333-54.044444H147.911111c-36.977778 0-71.111111 22.755556-85.333333 56.888889-11.377778 34.133333-5.688889 71.111111 19.911111 96.711111L341.333333 512v284.444444c0 28.444444 5.688889 39.822222 28.444445 56.888889l125.155555 93.866667c17.066667 11.377778 34.133333 19.911111 54.044445 19.911111 14.222222 0 28.444444-2.844444 39.822222-8.533333 31.288889-14.222222 36.977778-42.666667 36.977778-76.8V512l258.844444-244.622222c25.6-25.6 31.288889-65.422222 19.911111-99.555556zM844.8 227.555556l-256 244.622222-19.911111 14.222222v395.377778c0 19.911111-2.844444 22.755556-2.844445 22.755555l-2.844444 2.844445c-2.844444 2.844444-8.533333 2.844444-14.222222 2.844444s-14.222222-2.844444-19.911111-5.688889l-125.155556-93.866666c-2.844444-2.844444-5.688889-2.844444-5.688889-5.688889v-318.577778l-17.066666-17.066667L122.311111 227.555556c-8.533333-8.533333-11.377778-22.755556-5.688889-36.977778 5.688889-11.377778 17.066667-19.911111 31.288889-19.911111h674.133333c14.222222 0 25.6 8.533333 31.288889 19.911111 2.844444 11.377778 0 25.6-8.533333 36.977778z m36.977778 341.333333H739.555556c-14.222222 0-28.444444 14.222222-28.444445 28.444444s14.222222 28.444444 28.444445 28.444445h142.222222c14.222222 0 28.444444-14.222222 28.444444-28.444445s-14.222222-28.444444-28.444444-28.444444z m0 113.777778H739.555556c-14.222222 0-28.444444 14.222222-28.444445 28.444444s14.222222 28.444444 28.444445 28.444445h142.222222c14.222222 0 28.444444-14.222222 28.444444-28.444445s-14.222222-28.444444-28.444444-28.444444z m0 113.777777H739.555556c-14.222222 0-28.444444 14.222222-28.444445 28.444445s14.222222 28.444444 28.444445 28.444444h142.222222c14.222222 0 28.444444-14.222222 28.444444-28.444444s-14.222222-28.444444-28.444444-28.444445z',
                    onclick: () => {
                        this.showNewMenuSearch();
                    }
                },
                myTool2: {
                    show: true,
                    title: '排序',
                    icon: 'M156.392727 656.523636a43.52 43.52 0 0 1 61.207273 7.214546l113.105455 144.058182V90.298182a43.752727 43.752727 0 1 1 87.272727 0v843.403636a43.752727 43.752727 0 0 1-29.323637 41.425455 42.123636 42.123636 0 0 1-14.196363 2.327272 43.287273 43.287273 0 0 1-34.210909-16.756363L148.945455 717.730909a43.52 43.52 0 0 1 7.447272-61.207273zM634.414545 48.872727a43.752727 43.752727 0 0 1 48.64 14.429091l191.069091 242.967273a43.752727 43.752727 0 1 1-69.818181 53.992727l-111.941819-144.058182v717.498182a43.752727 43.752727 0 1 1-87.272727 0V90.298182a44.218182 44.218182 0 0 1 29.323636-41.425455z',
                    onclick: () => {
                        this.showOrderOptions();
                    }
                },
                magicType: {type: magicType},
                saveAsImage: {show: true},
                dataView: { // 数据视图
                    show: true,
                    optionToContent: function (opt) {
                        document.getElementById('biPager').setAttribute('hidden', 'hidden');
                        let axisData = opt.xAxis[0].data; // 坐标数据
                        let series = opt.series; // 折线图数据
                        let tdHeads = '<td  style="padding: 0 10px;border:1px solid #333;"></td>'; // 表头
                        let tdBodys = ''; // 数据
                        series.forEach(function (item) {
                            // 组装表头
                            tdHeads += `<td style="padding: 0 10px;border:1px solid #333;">${item.name}</td>`;
                        });
                        let table = `<table border="1" style="margin-left:20px;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
                        for (let i = 0, l = axisData.length; i < l; i++) {
                            for (let j = 0; j < series.length; j++) {
                                // 组装表数据
                                tdBodys += `<td style="padding: 0 10px;border:1px solid #333;">${series[j].data[i] === undefined || series[j].data[i] === null || series[j].data[i] === 'null' ? 0 : series[j].data[i].toString().replace(/\d+/, function (num) { // 先提取整数部分
                                    return num.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                                        return $1 + ',';
                                    });
                                })}</td>`;
                            }
                            table += `<tr><td style="padding: 0 10px;border:1px solid #333;">${axisData[i] === undefined || axisData[i] === null || axisData[i] === 'null' ? 0 : axisData[i].toString().replace(/\d+/, function (num) { // 先提取整数部分
                                return num.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                                    return $1 + ',';
                                });
                            })}</td>${tdBodys}</tr>`;
                            tdBodys = '';
                        }
                        table += '</tbody></table>';
                        return table;
                    },
                    buttonTextColor: '#f4f4f4',
                    lang: ['数据视图', '<span id="closeData" class="closeBtn" onclick="showpagerBi()">关闭</span>', '<span  class="refBtn">刷新</span>']
                }
            }
            // orient: 'vertical'
        };
        return {
            isCollapse: true,
            leftTitleFlag: true,
            sortType: 1,
            sortModel: 1,
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            isRefreshSel: false,
            isRefreshCondition: false,
            oldSelectedModel: {},
            tableColumns: [],
            searchLoadTimer: '',
            isShowSearchConditon: false,
            conditionFieldsNew: [],
            allData: [],
            page: {
                currentPage: 1, // 当前页码
                pageSize: 20, // 每页条数
                totalPageNum: 0 // 总页数
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 20, // 每页条数
                totalPageNum: 0 // 总页数
            },
            dataForm: {
                showSummary: false, // 是否要显示求和
                subformTableColumns: [],
                pageData: [],
                isShowOverflowTooltip: false,
                tableHeight: '380px'
            },
            time: new Date().getTime(),
            // biHeight: '33vw',
            biHeight: '100%',
            direction: 'ltr',
            isShowOrderOptions: false,
            orderOptions: [],
            columnsArray: []
        };
    },
    created () {
        // if (this.conditionFields && this.conditionFields.length > 0) {
        //     this.conditionFieldsNew = cloneDeep(this.conditionFields);
        // }
        this.isCollapse = this.isCollapseForInit;// 初始化左侧收起展开
        this.allData = this.chartData.rows;
        this.page.totalPageNum = this.chartData.rows.length;
        this.dealData(this.selectedModel, true);
        // this.buildColumnsAllData();  这个功能只给中泽的账龄BI上线，现在先注释掉
    },
    methods: {
        buildColumnsAllData () {
            let columnsArray = [];
            for (let i = 0; i < this.chartData.columns.length; i++) {
                let curItem = {columnName: this.chartData.columns[i], columnCount: 0};
                columnsArray.push(curItem);
            };
            for (let i = 0; i < this.allData.length; i++) {
                let curItem = this.allData[i];
                columnsArray.forEach(element => {
                    let columnName = element.columnName;
                    let num = curItem[columnName];
                    if (!num || num === 'null') {
                        num = 0;
                    }
                    element.columnCount += Number(num);
                });
            };
            this.columnsArray = columnsArray;
        },
        formatThousand (money) {
            let res = money.toString().replace(/\d+/, function (num) { // 先提取整数部分
                return num.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
                    return $1 + ',';
                });
            });
            return res;
        },
        dealData () {
            // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
            let cpage = (this.page.currentPage - 1) * this.page.pageSize;
            let count = this.page.pageSize + cpage;
            this.chartData.rows = this.allData.slice(cpage, count);
            if (this.chartData.rows.length < 1) {
                this.$message({
                    message: '没有查询到数据',
                    type: 'warning'
                });
            }
        },
        queryTableData (currentPage) {
            this.page.currentPage = currentPage;
            this.dealData();
        },
        handleSizeChange (val) {
            this.page.pageSize = val;
            this.dealData();
        },
        refreshData () {
            // 刷新BI
            this.page.currentPage = 1;
            this.page.pageSize = 10;
            this.$emit('getBiData', []);
            // 刷新数据源
            if (this.isShowModelFormList === 1) {
                this.formPage.currentPage = 1;
                this.formPage.pageSize = 10;
                this.searchParams.searchCondition = [];
                this.renderFormList(this.selectedModel);
            }
        },
        async handleFilterCondition () {
            this.isShowSearchConditon = false;
            if (this.isRefreshCondition) {
                let columns = cloneDeep(this.tableColumns);
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                this.conditionFields = await getFormFieldListByIds(idArr.join(','));
                this.isRefreshCondition = false;
            }
            this.isShowSearchConditon = true;
        },
        async resetSearchConditon () {
            this.conditionFields.length = 0;
            let columns = cloneDeep(this.tableColumns);
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            this.conditionFields = await getFormFieldListByIds(idArr.join(','));
            this.conditionFieldsNew = [];
            if (this.conditionFields && this.conditionFields.length > 0) {
                for (var i = 0; i < this.conditionFields.length; i++) {
                    if (this.conditionFields[i].type === 'subform') {
                        continue;
                    } else {
                        this.conditionFieldsNew.push(this.conditionFields[i]);
                    }
                }
            }
        },
        async renderFormList (model, isInitSearch, searchCondition) {
            this.oldSelectedModel = model;
            this.searchParams.selectedFields = '';
            this.isRefreshSel = true;
            this.isRefreshCondition = true;
            this.searchParams.searchCondition = searchCondition;
            this.sourceOptions = [];
            this.selectedModel = model;
            this.tableColumns = [];
            this.isSubform = false;
            this.tableLoading = true;
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            loading.close();
            this.pageData = [];
            if (formData.data) {
                let tableDatas = [];
                formData.data.forEach(item => {
                    let jsonObj = JSON.parse(item);
                    tableDatas.push(jsonObj);
                });
                this.dataForm.pageData = tableDatas;
            }
            if (formData.otherData && formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            this.dataForm.subformTableColumns = formData.otherData.subformTableColumns;
            if (isInitSearch) {
                this.$emit('refreshSearchConditon', this.tableColumns);
            }
            this.formPage = {
                currentPage: formData.currentPage,
                pageSize: formData.pageSize,
                totalPageNum: formData.totalPageNum
            };
        },
        async chooseSearchConditon () {
            this.isShowSearchConditon = false;
            let searchCondition = this.$refs.searchConditon.getSearchCondition();
            this.$emit('getBiData', searchCondition);
            this.searchParams.searchCondition = searchCondition;
            if (this.isShowModelFormList === 1) {
                this.renderFormList(this.selectedModel);
            }
        },
        collapseLeftSide () {
            this.$emit('collapseLeftSide', this.isCollapse);
        },
        changeLeftList () {
            this.isCollapse = true;
            this.$emit('setShowleftList');
            if (this.leftTitleFlag) {
                this.leftTitleFlag = false;
            } else {
                this.leftTitleFlag = true;
            }
        },
        queryFormData ({currentPage}) {
            this.formPage.currentPage = currentPage;
            this.renderFormList(this.selectedModel, null, this.conditionFields);
        },
        queryFormDataByPageSize ({pageSize}) {
            this.formPage.pageSize = pageSize;
            this.renderFormList(this.selectedModel, null, this.conditionFields);
        },
        async searchForList (searchCondition, isInitSearch) {
            this.$emit('getBiData', this.conditionFieldsNew);
            // this.renderFormList(this.selectedModel, false, this.conditionFieldsNew);
            this.isShowBiSearchSetting = false;
        },
        showList () {
            this.$emit('swtitcList');
        },
        showNewMenuSearch () {
            if (this.biConditionFields && this.biConditionFields.length > 0) {
                this.conditionFieldsNew = cloneDeep(this.biConditionFields);
                this.searchLoadTimer = new Date().getTime();
            } else {
                let param = {dataModelId: this.selectedModel.dataModelId, dataFormId: this.selectedModel.dataFormId};
                this.renderFormListSearch(param, true, null);
            }
            this.isShowSearchConditon = true;
        },
        showOrderOptions () {
            this.orderOptions = [];
            this.chartData.columns.forEach(item => {
                let optionObj = {};
                optionObj.value = item;
                optionObj.label = item;
                optionObj.children = [{value: 'asc', label: '升序'}, {value: 'desc', label: '降序'}];
                this.orderOptions.push(optionObj);
            });
            this.isShowOrderOptions = true;
        },
        sortSearch () {
            if (this.sortType === 1) {
                let checkedNodes = this.$refs.sortCascader.getCheckedNodes();
                if (checkedNodes && checkedNodes[0].path) {
                    this.sortData({sort: checkedNodes[0].path[1]}, checkedNodes[0].path[0]);
                    this.isShowOrderOptions = false;
                }
            } else if (this.sortType === 2) {
                if (this.sortModel === 1) {
                    this.chartSettings.metrics.sort(function (a, b) {
                        return a > b ? 1 : -1;
                    });
                } else {
                    this.chartSettings.metrics.sort(function (a, b) {
                        return a < b ? 1 : -1;
                    });
                }
                this.isShowOrderOptions = false;
            }
        },
        sortData (o, column) {
            this.allData.forEach(item => {
                item.sort = o.sort;
            });
            this.allData.forEach(item => {
                this.allData.sort(this.sortMethod(column, item.sort));
            });
            this.dealData();
            this.$forceUpdate();
        },
        sortMethod (prop, sortType) {
            return function (obj1, obj2) {
                var val1 = !isNaN(Number(obj1[prop])) ? Number(obj1[prop]) : 0;
                var val2 = !isNaN(Number(obj2[prop])) ? Number(obj2[prop]) : 0;
                if (val1 < val2) {
                    return sortType === 'asc' ? -1 : 1;
                } else if (val1 > val2) {
                    return sortType === 'asc' ? 1 : -1;
                } else {
                    return 0;
                }
            };
        },
        async renderFormListSearch (model, isInitSearch, searchCondition) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            if (formData.otherData && formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            this.refreshSearchConditon(this.tableColumns);
            loading.close();
        },
        async refreshSearchConditon (columns) {
            this.conditionFieldsNew.length = 0;
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            this.conditionFieldsNew = [];
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        this.conditionFieldsNew.push(cfs[i]);
                    }
                }
            }
            this.searchLoadTimer = new Date().getTime();
        },
        celSetForm () {
            this.conditionFieldsNew = [];
            this.isShowBiSearchSetting = false;
        },
        subSetForm () {
            this.isShowBiSearchSetting = false;
        }
    }
};
</script>
function showPagerFunc () {
    alert('33');
}
<style lang="less">
    .bi-show-dialog{
        .el-dialog__body{
            height: ~"calc(100% - 100px)";
            .BI-content{
                position: relative;
                width: 100%;
                height: 100%;
                .form-data-content{
                    height: 400px;
                    overflow: auto;
                }
                .BI-area{
                    position: relative;
                    width: 100%;
                    height: 100%;
                    text-align: center;
                    .BI-area-one{
                        position: relative;
                        height: 100%;
                        .ve-histogram{
                           height: ~"calc(100% + 30px)" !important;
                        }
                    }
                    .is-justify-end{
                        margin-top: -12px;
                    }
                }
               .model-desc {
                    .el-card__body {
                        margin-top:-18px;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                    }
                }
            }
        }
    }
    .el-collapse-item__wrap{
        overflow: auto;
    }
</style>


// WEBPACK FOOTER //
// src/components/DashBoard/DashBoard.vue